import { useState } from "react";
import { Search } from "lucide-react";

export const RoleSearch = ({ agents, deps, onPick }) => {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const hits = q.trim() ? agents.filter((a) => a.name.toLowerCase().includes(q.trim().toLowerCase())).slice(0, 8) : [];
  const pick = (a) => { setQ(""); setOpen(false); onPick(a); };
  return (
    <div className="relative w-full sm:w-72" data-testid="role-search">
      <Search className="w-3.5 h-3.5 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
      <input value={q} onChange={(e) => { setQ(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)}
        onKeyDown={(e) => { if (e.key === "Enter" && hits[0]) pick(hits[0]); }}
        placeholder="Find a role…" data-testid="role-search-input"
        className="w-full h-9 pl-9 pr-3 rounded-full bg-white/[0.04] border border-white/10 text-sm placeholder:text-muted-foreground focus:outline-none focus:border-[#D4FF3A]/50 transition-colors" />
      {open && hits.length > 0 && (
        <div className="absolute z-40 mt-2 w-full rounded-lg border border-white/10 bg-[#0A0A0F]/95 backdrop-blur-xl p-1 mh-enter" data-testid="role-search-results">
          {hits.map((a) => {
            const d = deps.find((x) => x.slug === a.department);
            return (
              <button key={a.slug} onMouseDown={(e) => e.preventDefault()} onClick={() => pick(a)} data-testid={`role-search-hit-${a.slug}`}
                className="w-full text-left px-3 py-2 rounded-md hover:bg-white/5 transition-colors flex justify-between gap-2 text-sm">
                <span className="truncate">{a.name}</span><span className="font-mono text-[10px] shrink-0" style={{ color: d?.hex }}>{d?.name}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
